import React from 'react';
import { Box, Container, Grid, Typography, Link, Divider } from '@mui/material';
import { Email, ChevronRight } from '@mui/icons-material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        position: 'relative',
        background:
          'radial-gradient(1200px 500px at 10% -10%, rgba(37,99,235,0.12) 0%, rgba(255,255,255,0) 60%),' +
          'radial-gradient(900px 450px at 90% 10%, rgba(99,102,241,0.10) 0%, rgba(255,255,255,0) 55%),' +
          'linear-gradient(180deg, #f8fafc 0%, #ffffff 70%)',
        color: 'text.primary',
        py: { xs: 5, md: 7 },
        mt: 10,
        borderTop: '1px solid',
        borderColor: 'divider',
        boxShadow: '0px -10px 30px rgba(2, 6, 23, 0.06)',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: 1.25,
          background: 'linear-gradient(90deg, #2563eb 0%, #6366f1 55%, #f59e0b 100%)',
          opacity: 0.25,
        },
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 4, md: 6 }}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Box>
            <Typography variant="h6" sx={{ fontWeight: 200, mb: 1, letterSpacing: 0.2 }}>
                Probate Bond Pros
              </Typography>
              <img
                src="/Probate.jpeg"
                alt="Probate Bond Pros"
                style={{
                  height: '60px',
                  width: 'auto',
                  marginBottom: '16px',
                  borderRadius: '12px',
                }}
              />
              <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.8, maxWidth: 360 }}>
                Your trusted partner for probate, guardianship, and fiduciary bonds. We simplify complex workflows so you don’t have to.
              </Typography>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ fontWeight: 200, mb: 2 }}>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
              {[
                { label: 'Request a Bond', href: '/bond-creation-outsider' },
                { label: 'Bond Calculator', href: '/premium_calculator' },
              ].map((link, index) => (
                <Link
                  key={index}
                  href={link.href}
                  underline="hover"
                  sx={{
                    color: 'text.secondary',
                    fontSize: 15,
                    lineHeight: 1.5,
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 0.75,
                    width: 'fit-content',
                    py: 0.6,
                    px: 0.75,
                    borderRadius: 1,
                    transition: 'all 0.18s ease',
                    '&:hover': {
                      color: '#2563eb',
                      backgroundColor: 'rgba(37, 99, 235, 0.08)',
                      transform: 'translateX(2px)',
                    },
                  }}
                >
                  <ChevronRight sx={{ fontSize: 16, opacity: 0.9 }} />
                  {link.label}
                </Link>
              ))}
            </Box>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ fontWeight: 200, mb: 2 }}>
              Contact & Support
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Box
                  sx={{
                    backgroundColor: '#2563eb',
                    borderRadius: '50%',
                    padding: '6px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Email sx={{ color: 'white', fontSize: 18 }} />
                </Box>
                <Box>
                  <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.4 }}>
                    Need help? Email our support team:
                  </Typography>
                  <Link
                    href="mailto:support@probatebondpros.com"
                    underline="hover"
                    sx={{
                      color: 'text.secondary',
                      fontSize: 14,
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 0.5,
                      transition: 'color 0.18s ease',
                      '&:hover': { color: '#2563eb' },
                    }}
                  >
                    support@probatebondpros.com
                  </Link>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* Divider */}
        <Divider sx={{ my: { xs: 4, md: 5 }, borderColor: 'divider' }} />

        {/* Bottom Row */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'center', md: 'space-between' },
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            gap: 2,
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            © {new Date().getFullYear()} Probate Bond Pros. All rights reserved.
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Powered by
            </Typography>
            <Box
              sx={{
                backgroundColor: 'rgba(2, 6, 23, 0.04)',
                padding: '6px 12px',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <img src="/logo.png" alt="Blue Ocean" style={{ height: '24px', width: 'auto' }} />
            </Box>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Blue Ocean Strategic Partners
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
